export var TPhaLocType;
(function (TPhaLocType) {
    TPhaLocType["SHOP"] = "SHOP";
    TPhaLocType["PROJECT"] = "PROJECT";
})(TPhaLocType || (TPhaLocType = {}));
export var TProHouseAccountAction;
(function (TProHouseAccountAction) {
    TProHouseAccountAction["ENROLL"] = "enroll";
    TProHouseAccountAction["UNENROLL"] = "unenroll";
})(TProHouseAccountAction || (TProHouseAccountAction = {}));
export const CNP_ENROLLMENT_ACTIONS = {
    PHONE_AUTH: ['AUTHORIZE_PAA'],
    T2C: ['AUTHORIZE_PAA', 'ENROLL_T2C'],
    REMOVE_T2C: ['STOP_T2C'],
    REMOVE_PHONE_AUTH_AND_T2C: ['STOP_PAA', 'STOP_T2C'],
    REMOVE_PHONE_AUTH: ['STOP_PAA'],
};
